// extracted by mini-css-extract-plugin
export default {"form":"string_form__onYQO","letters":"string_letters__6PhyV"};